module.exports = __webpack_public_path__ + "static/media/action-icon-buttons-outlined-32-black-right-arrow.1d81692c.svg";